// Desktop navigation only. Vessel continues to own the drawer, cart, account and search.
class JaxHueNavigation extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const signal = this.abort.signal;
    const cancelClose = () => {
      clearTimeout(this.closeTimer);
      this.closeTimer = undefined;
    };
    const disclosures = [...this.querySelectorAll('.jh-menu__disclosure')];
    const closeOthers = (current) => {
      for (const disclosure of disclosures) {
        if (disclosure !== current) disclosure.open = false;
      }
    };
    for (const disclosure of disclosures) {
      const summary = disclosure.querySelector('summary');
      const sync = () => summary.setAttribute('aria-expanded', String(disclosure.open));
      sync();
      disclosure.addEventListener('toggle', () => {
        if (disclosure.open) closeOthers(disclosure);
        sync();
      }, { signal });
      disclosure.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !matchMedia('(hover:hover)').matches) return;
        cancelClose();
        closeOthers(disclosure);
        disclosure.open = true;
        sync();
      }, { signal });
      summary.addEventListener('click', (event) => {
        // Mouse hover already opened the menu; clicking must not immediately collapse it.
        // Keyboard and touch clicks retain the native details toggle behavior.
        if (event.pointerType !== 'mouse' || !matchMedia('(hover:hover)').matches) return;
        event.preventDefault();
        cancelClose();
        closeOthers(disclosure);
        disclosure.open = true;
        sync();
      }, { signal });
      disclosure.addEventListener('focusout', (event) => {
        if (!disclosure.contains(event.relatedTarget)) disclosure.open = false;
      }, { signal });
    }
    // Keep the whole navigation row and its full-width panel in one hover region.
    this.addEventListener('pointerenter', cancelClose, { signal });
    this.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      cancelClose();
      this.closeTimer = setTimeout(() => {
        this.closeTimer = undefined;
        if (!this.querySelector(':focus-visible')) closeOthers(null);
      }, 250);
    }, { signal });
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        cancelClose();
        closeOthers(null);
      }
    }, { signal });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = disclosures.find(disclosure => disclosure.open);
      if (open) {
        event.preventDefault();
        cancelClose();
        open.open = false;
        open.querySelector('summary').focus();
      }
    }, { signal });
  }
  disconnectedCallback() {
    clearTimeout(this.closeTimer);
    this.abort?.abort();
  }
}
if (!customElements.get('jax-hue-navigation')) {
  customElements.define('jax-hue-navigation', JaxHueNavigation);
}
